export default [
  { key: 'name', i18nKey: 'privacyControl.table.name', tdClass: 'align-middle', sortable: true },
  { key: 'email', i18nKey: 'privacyControl.table.email', tdClass: 'align-middle', sortable: true },
  { key: 'createdAt', i18nKey: 'privacyControl.table.createdAt', tdClass: 'align-middle', sortable: true },
  { key: 'action', label: '', tdClass: 'text-nowrap align-middle text-center' },
];
